import { serviceMappings } from 'features/bot-builder/constants';
import { Play } from 'lucide-react';

interface ServiceChecksProps {
  label: string;
  disabled?: boolean;
  isChecked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  setChatWkbOpen?: (open: boolean) => void;
}

export const ServiceChecks = ({
  label,
  disabled,
  isChecked,
  onChange,
  setChatWkbOpen,
}: ServiceChecksProps) => {
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    onChange(event); // Call the parent-provided onChange

    // Open ChatWithKB dialog if the label is 'chatwkb'
    if (label === 'chatwkb' && setChatWkbOpen) {
      setChatWkbOpen(isChecked); // Open or close ChatWithKB based on checkbox state
    }
  };
  const service = serviceMappings[label] || { label, icon: Play };

  return (
    <div className="flex flex-row items-center justify-between h-12 bg-white dark:bg-[#2B2B2B] text-text-primary dark:text-white rounded-md border border-gray-200 dark:border-gray-700">
      <div className="bg-black h-full flex items-center justify-center rounded-l-md w-[15%]">
        {label === 'explain_like_five' ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            width="50"
            height="50"
            className="text-primary w-5 h-5"
          >
            <path d="M17 4H9l-1 6h6a4 4 0 1 1-4 4" />
          </svg>
        ) : (
          service.icon && (
            <service.icon className="cursor-pointer w-4 h-4 text-primary" />
          )
        )}
      </div>

      <div className="flex flex-row gap-2 items-center w-[85%] justify-between pr-4 h-12 rounded-r-md pl-2 cursor-pointer">
        <div className="flex gap-2 items-center">
          <label
            htmlFor={label}
            className="line-clamp-2 font-medium text-[14px]"
          >
            {service.label}
          </label>
          {label === 'chatwkb' && (
            <span className="font-bold text-primary text-[10px] px-1 py-0.5 bg-purple-100 rounded">NEW</span>
          )}
        </div>

        <input
          title={label}
          id={label}
          type="checkbox"
          className="h-4 w-4 border-[2px] border-input rounded-sm focus:outline-none checked:bg-[#846CEC] focus:ring-0 focus:border-0 checked:focus:bg-[#846CEC] disabled:bg-input"
          disabled={disabled}
          checked={isChecked}
          onChange={handleInputChange}
        />
      </div>
    </div>
  );
};
